import { useState, useContext, useEffect } from 'react'
import { Select, MenuItem, SelectChangeEvent, FormControl, InputLabel, Button } from '@mui/material'
import { languageList } from './Languages/index'
import Language from '@mui/icons-material/Language'

import { PolyglotContext } from './polyGlotContext'
import { PolyglotLanguageType } from './languageType'
import { updateCustomerLanguagePref, userHasLanguage, userHasSettings } from '../firebase/databaseApi'
import { useCurrentUser, useReloadCurrentUser } from '../hooks/contexts/currentUserContext'

const LanguageSelect = () => {
    const { setActiveLanguage } = useContext(PolyglotContext)

    const currentUser = useCurrentUser()
    const reloadCurrentUser = useReloadCurrentUser()
    const customerId = currentUser?.customer?.id

    const [selectedLanguage, setSelectedLanguage] = useState('')

    const handleChange = (event: SelectChangeEvent<string>) => {
        setSelectedLanguage(event.target.value)
        setActiveLanguage(event.target.value as PolyglotLanguageType)

        if (customerId) {
            reloadCurrentUser()
            updateCustomerLanguagePref(customerId, selectedLanguage as PolyglotLanguageType)
        }
    }

    const setSelected = async () => {
        if (customerId) {
            const hasSettings = await userHasSettings(customerId)
            if (hasSettings) {
                const userLanguage = await userHasLanguage(customerId)
                if (!userLanguage) {
                    return 'sv'
                } else {
                    return userLanguage
                }
            } else {
                return 'sv'
            }
        }
    }

    useEffect(() => {
        const fetchSelected = async () => {
            const result = await setSelected()
            setSelectedLanguage(result)
        }
        fetchSelected()
    }, [])

    return (
        <FormControl sx={{ minWidth: '5rem' }}>
            <InputLabel id="languageLabel">
                <Language />
            </InputLabel>
            <Select labelId="languageLabel" value={selectedLanguage} onChange={handleChange}>
                {languageList.map((language, index) => {
                    return (
                        <MenuItem key={index} value={language}>
                            {' '}
                            {language.toUpperCase()}
                        </MenuItem>
                    )
                })}
            </Select>
        </FormControl>
    )
}

export default LanguageSelect
